import React, { FunctionComponent } from 'react';

import Form from './Form';

const Netbanking: FunctionComponent<{
  paymentModes: Array<object>;
  amount: number;
  updateInternetCharges: Function;
  type: string;
  paymentInfo: any;
  internetCharges: number;
  fromFastag: any;
}> = ({ paymentModes, amount, updateInternetCharges, type, paymentInfo, internetCharges, fromFastag }) => {
  const netbankingOptions: any =
    paymentModes && paymentModes.length ? paymentModes.find((mode: any) => mode.paymentMode === 'NET_BANKING') : {};
  const bankOptions = netbankingOptions ? netbankingOptions.payChannelOptions : [];
  return (
    <div>
      <Form
        bankOptions={bankOptions}
        amount={amount}
        paymentInfo={paymentInfo}
        updateInternetCharges={updateInternetCharges}
        type={type}
        internetCharges={internetCharges}
        fromFastag={fromFastag}
      />
    </div>
  );
};

export default Netbanking;
